'use strict';

define(['$window'], function ($window) {

  var ensureAriaLabelledByIdsAreUnique = function ensureAriaLabelledByIdsAreUnique(component) {
    component.querySelectorAll('[aria-labelledby]').forEach(function (container) {
      var labelID = container.getAttribute('aria-labelledby');
      if (labelID) {
        var label = component.querySelector('#' + labelID);

        if (label) {
          var uniqueId = $window.getUUID(labelID);
          container.setAttribute('aria-labelledby', '' + uniqueId);
          label.setAttribute('id', '' + uniqueId);
        } else {
          container.removeAttribute('aria-labelledby');
        }
      }
    });
  };

  return {
    ensureAriaLabelledByIdsAreUnique: ensureAriaLabelledByIdsAreUnique
  };
});
//# sourceMappingURL=uniqueIDHelper.js.map
